import css from 'styled-jsx/css';
import { sharedPalette } from 'styles/colors/constants';
import { sansSerif } from 'styles/css-constants';
import { MQ_LARGE } from 'constants/mq';

const brandColor = sharedPalette.watermelon;

export default css`
  .Tip {
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
  }

  .Tip__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }

  .Tip__header--left,
  .Tip__header--right {
    flex: flex-grow;
    flex-grow: 1;
    width: auto;
    height: 1px;
    background-color: ${brandColor};
  }

  .Tip__header--middle {
    font-family: ${sansSerif};
    font-size: var(--baseFontSize);
    font-weight: 500;
    color: ${brandColor};
    text-transform: uppercase;
    text-align: center;
    padding: 0 0.5rem;
  }

  .Tip__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: var(--fontScale1);
    font-family: ${sansSerif};
    padding: 1rem 0;
    line-height: 1.5;
  }

  .Tip__content :global(a) {
    border-bottom: 1px solid ${brandColor};
    color: #000;
  }

  .Tip__footer {
    height: 1px;
    width: 100%;
    background-color: ${brandColor};
  }

  .Tip__cta {
    display: flex;
    justify-content: flex-end;
    padding-top: 0.5rem;
    margin-bottom: 1.5rem;
  }

  .Tip__cta a {
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    font-weight: bold;
    color: ${brandColor};
    text-transform: uppercase;
  }

  /* Taryn's Tips Campaign */
  .Tip--taryns-tips .Tip__header--left,
  .Tip--taryns-tips .Tip__header--right {
    background-color: #ca39a5;
  }

  .Tip--taryns-tips .Tip__header--middle span {
    display: none;
  }

  .Tip--taryns-tips .Tip__header--middle::before {
    content: '';
    background: url('https://cdn.apartmenttherapy.info/image/upload/f_auto,q_auto:eco,c_fill,g_auto/v1604343126/decluttering-cure-2020/taryns-tips-graphic.png');
    background-size: 236px 60px;
    background-repeat: no-repeat;
    width: 236px;
    height: 60px;
    display: inline-flex;
  }

  .Tip--taryns-tips .Tip__content {
    color: #ca39a5;
    padding: 1rem 0 2rem 0;
    font-size: var(--fontScale2);
  }

  .Tip--taryns-tips .Tip__content :global(a) {
    border-bottom: 1px solid #ca39a5;
    color: #ca39a5;
  }

  .Tip--taryns-tips .Tip__footer {
    background-color: #ca39a5;
  }

  .Tip--taryns-tips .Tip__cta a {
    font-family: ${sansSerif};
    font-size: var(--fontScale1);
    font-weight: bold;
    color: #ca39a5;
    text-transform: uppercase;
  }
  /* end of Taryn's Tips Campaign */

  @media ${MQ_LARGE} {
    .Tip {
      padding: 0 5rem;
    }

    .Tip__content {
      padding: 2rem 0;
      text-align: center;
    }

    .Tip--taryns-tips .Tip__content {
      padding: 1.5rem 1.5rem 2.5rem 1.5rem;
    }
  }
`;
